import { create } from 'zustand';
import { EntityName } from 'shared/domain/entityName';
import { visibleFieldClient } from 'shared/domain/visibleField/visibleFieldClient';
import type { VisibleFieldModel } from 'shared/domain/visibleField/visibleFieldModel';
import { createSelectors, StoreName, withDevtools } from '../config';
import { createEntityCollectionActions } from '../entityCollection';
import { createDataActions, createInitialActionsState, createInitialData, makeAction } from '../types';
import type { VisibleFieldStore } from './types';
import { visibleFieldActionNames } from './types';

const useVisibleFieldStoreBase = create<VisibleFieldStore>()(
  withDevtools(
    (set, get) => ({
      data: createInitialData<VisibleFieldModel>(),
      _actionStates: createInitialActionsState(visibleFieldActionNames),

      actions: {
        ...createDataActions<VisibleFieldModel, VisibleFieldStore>(set),
        ...createEntityCollectionActions(
          { client: visibleFieldClient, entityName: EntityName.visibleFields },
          () => get().actions
        ),
        reset: () =>
          set((state) => ({
            ...state,
            data: { items: [], loading: true },
            _actionStates: createInitialActionsState(visibleFieldActionNames),
          })),
      },

      // The worker stores what the server saved; the fields are read again from it.
      asyncActions: {
        edit: makeAction(set, 'edit', async (_set, visibleFieldsEdit) => {
          await visibleFieldClient.edit(visibleFieldsEdit);
          await get().actions.reload();
        }),
      },
    }),
    StoreName.VisibleFields
  )
);

export const useVisibleFieldStore = createSelectors(useVisibleFieldStoreBase);

export const getVisibleFieldStoreState = (): VisibleFieldStore => useVisibleFieldStore.getState();
